import HTTPResponse from '../HttpResponse';

import HttpClient from '../HttpClient';
import { Question, AnswerPayload } from './model';

class AdditionalInfoService {
  private httpBoka: HttpClient;

  constructor(httpBoka: HttpClient) {
    this.httpBoka = httpBoka;
  }

  public getQuestions = async (
    questionToken?: string,
  ): Promise<HTTPResponse<Question[]>> => {
    let res;
    try {
      const result = await this.httpBoka.get(
        `/appointment/questions/${questionToken}`,
      );
      res = result.data;
      return new HTTPResponse(res);
    } catch (err: any) {
      const { response } = err;
      return new HTTPResponse(res, response);
    }
  };

  public getMandatoryQuestions = async (
    serviceId: string,
    retryOnce = true,
  ): Promise<HTTPResponse<Question[]>> => {
    try {
      const result = await this.httpBoka.get(
        `/services/questions/${serviceId}`,
      );
      return new HTTPResponse(result.data);
    } catch (err: any) {
      if (retryOnce) {
        return this.getMandatoryQuestions(serviceId, false);
      }
      return new HTTPResponse([]);
    }
  };

  public postAnswers = async (
    questionToken: string,
    answers: AnswerPayload[],
  ): Promise<HTTPResponse<AnswerPayload[]>> => {
    let res;
    try {
      const result = await this.httpBoka.post(
        `/appointment/answers/${questionToken}`,
        answers,
      );
      res = result.data;
      return new HTTPResponse(res);
    } catch (err: any) {
      const { response } = err;
      return new HTTPResponse(res, response);
    }
  };
}

export default AdditionalInfoService;
